var map = {
	"./Authentication.vue": [
		1542,
		1542
	],
	"./CreateNewCustomer.vue": [
		9920,
		6678,
		9920
	],
	"./CreateNewCustomerAddress.vue": [
		4379,
		6678,
		4379
	],
	"./History.vue": [
		7993,
		8119,
		1476
	],
	"./Kiosk.vue": [
		7050,
		7050
	],
	"./Login.vue": [
		5196,
		5196
	],
	"./LoginStaff.vue": [
		8910,
		8910
	],
	"./Logout.vue": [
		6982,
		6982
	],
	"./Nonpackage.vue": [
		3408,
		3408
	],
	"./NotFoundPage.vue": [
		684,
		684
	],
	"./Payment.vue": [
		806,
		806
	],
	"./Product.vue": [
		8021,
		8021
	],
	"./PublicCustomerInfo.vue": [
		6594,
		6594
	],
	"./Questionnaire.vue": [
		9635,
		9635
	],
	"./QuotationEdit.vue": [
		2294,
		6678,
		2294
	],
	"./QuotationView.vue": [
		6520,
		3074,
		6520
	],
	"./RenewalView.vue": [
		443,
		443
	],
	"./Report.vue": [
		9091,
		9091
	],
	"./Sme.vue": [
		5360,
		5360
	],
	"./Sme360.vue": [
		4344,
		4344
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5858;
module.exports = webpackAsyncContext;